import { get, isEmpty } from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';
import { intervalSelector } from '@store/common/selectors';
import { SCOPE } from './types';
import { modeSelector } from '../selectors';
import { MODE_AI_ALERT_DIAGNOSTICS } from '../constants';
import { DEFAULT_METRIC } from '@src/utils/constants';

const selector = (state) => get(state, SCOPE);

export default selector;

export const aiAlertSelector = createSelector(selector, (alerts) => alerts);

export const selectedAiAlertSelector: any = createSelector(selector, (alerts) =>
  get(alerts, 'selectedAiAlert'),
);

export const selectedAiAlertIdSelector = createSelector(selectedAiAlertSelector, (alert) =>
  get(alert, 'alertId', null),
);

export const selectedAiAlertMetricSelector: any = createSelector(selector, (alerts) =>
  get(alerts, 'selectedAlertMetric', DEFAULT_METRIC),
);

// TODO: post depricating old trends, all alert state and actions can be localized to the temp dashboards state
// like use a temp dashboard level jotai store and load it with alert context
// we won't have to worry about resets and cleanups

export const hasAiAlertSelector: any = createSelector(
  selectedAiAlertSelector,
  modeSelector,
  (alert, { mode }) => {
    return (
      (mode === MODE_AI_ALERT_DIAGNOSTICS ||
        window.location.pathname.includes('/ai-alerts/diagnostics')) &&
      !isEmpty(alert)
    );
  },
);

export const includesAiAlertEventWindowSelector = createSelector(
  selectedAiAlertSelector,
  intervalSelector,
  hasAiAlertSelector,
  (alert, interval, hasAiAlert) => {
    if (!hasAiAlert) {
      return false;
    }

    try {
      const { graphSeries } = alert;

      const alertSeriesData = graphSeries?.[0]?.data;

      // If the All Exception data is empty, we use the diagnostic data to calculate the start and end time
      // https://conviva.atlassian.net/browse/CE-9244
      const aiAlertGraphStartTime = alertSeriesData?.[0]?.[0] || alert.startTimestamp;
      const aiAlertGraphEndTime =
        alertSeriesData?.[alertSeriesData?.length - 1]?.[0] || alert.endTimestamp;

      if (!aiAlertGraphStartTime || !aiAlertGraphEndTime) {
        return false;
      }

      return (
        moment(interval.from).isSameOrBefore(aiAlertGraphStartTime) &&
        moment(interval.to).isSameOrAfter(aiAlertGraphEndTime)
      );
    } catch (err) {
      console.error('includesAiAlertEventWindowSelector error', err);
    }

    return false;
  },
);

export const aiAlertMetricSelector = createSelector(selectedAiAlertSelector, (alert) =>
  get(alert, 'metricName', null),
);
